import { Form, Input, DatePicker, TimePicker, InputNumber, Button, Modal } from "antd";
import { observer } from "mobx-react";
import { UserOutlined, PhoneOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { reservationState } from "./ReservationState";
import './reservation.css'

const Reservation=()=>{
    return(
    <div className="reservation container mx-auto">
        <div className="reservation-title text-2xl text-center font-bold pt-5">Đặt bàn trực tiếp tại <span className="text-signature text-4xl">Nhoằm nhoằm</span></div>
        <div className="reservation-form">
            <Form onFinish={()=>{reservationState.handleShowConfirmModal()}}>
                <Form.Item className="hover:border-red-100" labelCol={{span: 24}} wrapperCol={{span: 8}} name="name" label="Tên người đặt bàn:" rules={[{required: true, message: 'Vui lòng điền Tên người đặt bàn'}]}>
                    <Input onChange={(event)=>{reservationState.reservationName = event.target.value}} placeholder="Vui lòng điền Tên người đặt bàn" prefix={<UserOutlined/>}/>
                </Form.Item>
                <Form.Item labelCol={{span: 24}} wrapperCol={{span: 8}} name="phone-number" label="Số điện thoại đặt bàn:" rules={[{required: true, message: 'Vui lòng điền Số điện thoại'}]}>
                    <Input onChange={(event)=>{reservationState.reservationPhoneNumber = event.target.value}} placeholder="Vui lòng điền Tên người đặt bàn" prefix={<PhoneOutlined/>}/>
                </Form.Item>
                <Form.Item
                labelCol={{span: 24}} wrapperCol={{span: 8}}
                label="Chọn thời gian"
                name="time"
                rules={[{ required: true, message: 'Vui lòng chọn thời gian' }]}
                >
                    <TimePicker
                        format="HH:mm"
                        minuteStep={30}
                        disabledTime={reservationState.disablePastTimeAntd}
                        showNow={false}
                        placeholder="Chọn thời gian"
                        onChange={(time, formattedHour) => { reservationState.reservationHour = String(formattedHour) }}
                    />
                </Form.Item>

                <Form.Item
                labelCol={{span: 24}} wrapperCol={{span: 8}}
                label="Chọn ngày"
                name="date"
                rules={[{ required: true, message: 'Vui lòng chọn ngày' }]}
                >
                    <DatePicker
                        format="DD/MM/YYYY"
                        placeholder="Chọn ngày"
                        disabledDate={reservationState.disablePastDates}
                        onChange={(date, formattedDate) => { reservationState.reservationDate = String(formattedDate) }}
                    />
                </Form.Item>
                <Form.Item labelCol={{span: 24}} wrapperCol={{span: 8}} label="Số người" name="people_amount" rules={[{required: true, message: 'Vui lòng điền Số người tới'}]}>
                    <InputNumber onChange={(event)=>{reservationState.reservationPeopleAmount = Number(event)}} placeholder="Số người" prefix={<UserOutlined/>}/>
                </Form.Item>
                <Form.Item labelCol={{span: 24}} wrapperCol={{span: 8}} label="Ghi chú" name="note">
                    <Input onChange={(value)=>{reservationState.reservationNote = value.target.value}} placeholder="Vui lòng điền Tên người đặt bàn" prefix={<InfoCircleOutlined/>}/>
                </Form.Item>
                <Button type="primary" htmlType="submit" danger>Đặt bàn</Button>
            </Form>
        </div>
        <Modal title="Xác nhận thông tin đặt bàn" open={reservationState.modalOpenStatus}
        onCancel={()=>{reservationState.modalOpenStatus = false}}
        footer={[
            <Button key="cancel" onClick={()=>{reservationState.handleCloseConfirmModal()}} style={{ backgroundColor: 'red', color: 'white' }}>
                Huỷ
            </Button>,
            <Button key="ok" type="primary" style={{ backgroundColor: 'red', color: 'white' }} onClick={()=>{reservationState.handleFormSending()}}>
                Đặt bàn
            </Button>
            ]}>
            <div className="grid grid-cols-6 gap-y-2">
                <div className="col-span-2">Tên người đặt bàn:</div><div className="col-span-4 font-bold">{reservationState.reservationName}</div>
                <div className="col-span-2">Số điện thoại đặt bàn:</div><div className="col-span-4 font-bold">{reservationState.reservationPhoneNumber}</div>
                <div className="col-span-2">Thời gian đặt bàn:</div><div className="col-span-4 font-bold">{reservationState.reservationHour}, {reservationState.reservationDate}</div>
                <div className="col-span-2">Số người:</div><div className="col-span-4 font-bold">{reservationState.reservationPeopleAmount}</div>
                <div className="col-span-2">Ghi chú:</div><div className="col-span-4 font-bold">{reservationState.reservationNote.length === 0 ? reservationState.reservationNote : ('Không có')}</div>
            </div>
      </Modal>
    </div>)
}
export default observer(Reservation)